import {AIMarkingType} from "../types/AIMarkingType";

interface Params {
    isModified?: boolean;
    isCreated?: boolean;
}

export const getAIMarkingTypeFromFlags = (params: Params): AIMarkingType | null => {
    if (params.isCreated) {
        return "ai-generated";
    }

    if (params.isModified) {
        return "ai-modified";
    }

    return null;
};
import {AIMarkingType} from "../types/AIMarkingType";

interface Params {
    isModified?: boolean;
    isCreated?: boolean;
}

export const getAIMarkingTypeFromFlags = (params: Params): AIMarkingType | null => {
    if (params.isCreated) {
        return "ai-generated";
    }

    if (params.isModified) {
        return "ai-modified";
    }

    return null;
};
